// extracted by mini-css-extract-plugin
export var colCreatedDate = "survey-session-column-item-module--col-created-date--oxkis";
export var colEmail = "survey-session-column-item-module--col-email--9Obmf";
export var colOccasion = "survey-session-column-item-module--col-occasion--HB9TW";
export var colStatus = "survey-session-column-item-module--col-status--W-lOj";
export var surveySessionColumnItem = "survey-session-column-item-module--survey-session-column-item--gRA-4";